export { INVALID_PHONE_NUMBER_ERROR, INVALID_COUNTRY_CODE_ERROR  } from './lib/errorConsts';

export { DEFAULT_SIDENAV_COLLAPSED_STATE } from './lib/sidenav';
export { supportedLocales } from './lib/locales';
export { defaultPageSizes } from './lib/table';
export { RESPONSE_CODES, UNAUTHORIZED_RESPONSE_MESSAGE } from './lib/httpResponseConsts';
export { CURRENCY_SYMBOLS } from './lib/currencies';
export { FILTER_START_DATE_RANGE_KEY,
    FILTER_END_DATE_RANGE_KEY,
    TODAY_CHECKBOX_KEY,
    DATE_FORM_FILED_KEYS,
    INVALID_DATE_RANGE_ERROR,
    DATE_RANGE_LIMIT,
    DATE_RANGE_LIMIT_ERROR,
    FIELD_KEYS_WITH_DATE_RANGE_EXCEED_LIMIT_VALIDATOR,
    NUMBER_RANGE_START_KEY,
    NUMBER_RANGE_END_KEY,
    TIME_RANGE_START_KEY,
    TIME_RANGE_END_KEY,
    INVALID_TIME_ERROR,
    INVALID_TIME_RANGE_ERROR,
    HOURS_KEY,
    MINUTES_KEY,
    DATE_TIME_DEFAULT_VALUES,
    HEADER_FILTERS_STORAGE_KEY,
    MAX_FIELD_LENGTH
} from './lib/fieldConsts';

export const LOCAL_STORAGE_BRANCH_KEY = 'currentBranch';

export const FILTERS_CALC_FIELDS_KEYS = [
    'HasVolumePalletRange',
    'HasVolumePalletSpaces',
    'HasFloorPalletRange',
    'HasTrafficFlow',
    'HasProductGroup',
    'OneOfLegTypes',
    'IsVLType',
    'IsHLType',
    'IsNlType'
];

export const REFRESH_MESSAGE_KEY = 'TRIGGER_UPDATE';